export default __webpack_public_path__ + "ui/assets/img/arrow-left-white-32.svg";